import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "56c3f2D5VhOhpM1VjTlHyZ7", "MoveAct", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, v2, tween, v3, UITransform, CCBoolean } from "cc";
import { E_EasingType } from "../EnumBase";
import { App } from "../manager/App";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_MoveActType;

(function (E_MoveActType) {
  E_MoveActType[E_MoveActType["Normal"] = 0] = "Normal";
  E_MoveActType[E_MoveActType["L2R_bounce"] = 1] = "L2R_bounce";
  E_MoveActType[E_MoveActType["L2R_BgRepeat"] = 2] = "L2R_BgRepeat";
  E_MoveActType[E_MoveActType["M2D_Normal"] = 3] = "M2D_Normal";
  E_MoveActType[E_MoveActType["L2R_MoveFoce"] = 4] = "L2R_MoveFoce";
})(E_MoveActType || (E_MoveActType = {}));

var MoveAct = (_dec = ccclass('MoveAct'), _dec2 = menu("act/MoveAct"), _dec3 = property({
  type: Enum(E_MoveActType)
}), _dec4 = property({
  type: Enum(E_EasingType),
  tooltip: "缓动动作"
}), _dec5 = property({
  visible: function visible() {
    return this.type != E_MoveActType.L2R_BgRepeat;
  }
}), _dec6 = property({
  type: CCBoolean,
  visible: function visible() {
    return this.type == E_MoveActType.L2R_BgRepeat;
  }
}), _dec7 = property({
  tooltip: "是否加载后，直接播放"
}), _dec(_class = _dec2(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MoveAct, _Component);

  function MoveAct() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "easingType", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "delayPos", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "speed", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "clockwise", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isPlayedOnLoad", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_easing", "");

    return _this;
  }

  var _proto = MoveAct.prototype;

  _proto.start = function start() {
    if (this.isPlayedOnLoad) {
      this.act();
    }
  };

  _proto.act = function act() {
    switch (this.type) {
      case E_MoveActType.L2R_bounce:
        this.handle_l2r_bounce();
        break;

      case E_MoveActType.M2D_Normal:
        this.handle_m2d_normal();
        break;

      case E_MoveActType.L2R_BgRepeat:
        this.handle_l2r_bgRepeat();
        break;

      case E_MoveActType.L2R_MoveFoce:
        this.handle_l2r_moveForce();
        break;
    }
  };

  _proto.handle_l2r_bounce = function handle_l2r_bounce() {
    if (this.easingType != E_EasingType.None) {
      this._easing = E_EasingType[this.easingType];
    } else {
      this._easing = "";
    }

    var t = this.delayPos.length() / this.speed;
    tween(this.node).repeatForever(tween().by(t, {
      position: v3(this.delayPos.x, this.delayPos.y, 0)
    }, {
      easing: this._easing
    }).by(t, {
      position: v3(-this.delayPos.x, -this.delayPos.y, 0)
    }, {
      easing: this._easing
    })).start();
  };

  _proto.handle_m2d_normal = function handle_m2d_normal() {
    var t = this.delayPos.length() / this.speed;
    var n_cpm = this.node;
    tween(n_cpm).repeatForever(tween().by(t, {
      position: v3(this.delayPos.x, this.delayPos.y)
    }, {
      easing: "sineInOut"
    }).by(t, {
      position: v3(-this.delayPos.x, -this.delayPos.y)
    }, {
      easing: "sineInOut"
    })).start();
  };

  _proto.handle_l2r_moveForce = function handle_l2r_moveForce() {
    if (this.easingType != E_EasingType.None) {
      this._easing = E_EasingType[this.easingType];
    } else {
      this._easing = "";
    }

    var t = this.delayPos.length() / this.speed;
    tween(this.node).repeatForever(tween().by(t, {
      position: v3(this.delayPos.x, this.delayPos.y, 0)
    }, {
      easing: this._easing
    })).start();
  };

  _proto.handle_l2r_bgRepeat = function handle_l2r_bgRepeat() {
    var _this2 = this;

    var x_init = this.node.position.x;
    var w_n = this.node.getComponent(UITransform).contentSize.width / 4;

    if (this.clockwise) {
      var x_cur = this.node.worldPosition.x;
      var x_offset = App.DataMgr.visibleSize.width - x_cur + w_n;
      var x_end = this.node.position.x + x_offset;
      var x_begin = this.node.position.x - (App.DataMgr.visibleSize.width - x_offset + w_n + w_n);
      var t_1 = x_offset / this.speed;
      var t = (x_end - x_begin) / this.speed;
      tween(this.node).repeatForever(tween(this.node).by(t_1, {
        position: v3(x_offset, 0, 0)
      }).call(function () {
        _this2.node.setPosition(x_begin, _this2.node.position.y, 0);
      }).by(t - t_1, {
        position: v3(x_init - x_begin, 0, 0)
      })).start();
    } else {
      var _x_cur = this.node.worldPosition.x;

      var _x_offset = -_x_cur - this.node.getComponent(UITransform).contentSize.width / 4;

      var _x_end = this.node.position.x + _x_offset;

      var _x_begin = this.node.position.x + App.DataMgr.visibleSize.width + _x_offset + w_n + w_n;

      var _t_ = -_x_offset / this.speed;

      var _t = (_x_begin - _x_end) / this.speed;

      tween(this.node).repeatForever(tween().by(_t_, {
        position: v3(_x_offset, 0, 0)
      }).call(function () {
        _this2.node.setPosition(_x_begin, _this2.node.position.y, 0);
      }).by(_t - _t_, {
        position: v3(x_init - _x_begin, 0, 0)
      })).start();
    }
  } // update (dt) {}
  ;

  return MoveAct;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_MoveActType.L2R_BgRepeat;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "easingType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_EasingType.None;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "delayPos", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return v2(0, 0);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "speed", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 80;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "clockwise", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "isPlayedOnLoad", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class);
export { MoveAct as default };

_cclegacy._RF.pop();